import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`2012 年創立 fable，fable 之拉丁字源 fabula，也就是「小故事」，引申為寓言故事之意。這是 fable 成立之本意，希望在較為冰冷的軟體世界，加入多一點的人性元素，讓所有跟我們合作的客戶，得到的不只是開發上的專業，更是一個可信賴的合作夥伴。
fable 提供數位科技管理顧問以及開發服務，協助企業規劃並客製化開發需要的網路平台。在這快速發展的數位世界裡，我們專注在如何利用外包開發資源，強化客戶內部能量，讓每一個產品發揮它的價值，希望所有合作夥伴在數位時代皆能取得新商機或優勢，便是我們最大的使命。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      